import React from 'react'
import './DescriptionBox.css'

function DescriptionBox() {
  return (
<div className="descriptionbox">
    <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Review (122)</div>
    </div>
    <div className="descriptionbox-description">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi doloremque rerum dolores laboriosam necessitatibus a alias inventore quae consequatur in, aut ratione ut quod neque, voluptates perspiciatis obcaecati eligendi soluta impedit ipsum omnis. Nam tenetur, nemo iste cupiditate doloribus ut fugiat dolores dolorum a, libero repellat odit harum perferendis architecto facilis neque ex dolorem. Maiores, autem saepe ut nihil aut repellat, necessitatibus quibusdam animi illum error facere, quasi itaque dolorem perspiciatis. Et, inventore sunt in voluptate qui impedit quod rerum unde ex odit velit dolorem asperiores nostrum consectetur ratione ut autem iure laborum quidem animi neque eveniet fuga officia repellat. Nulla explicabo beatae voluptatibus, maxime reprehenderit debitis in est assumenda sunt numquam, consequatur illo omnis aspernatur cupiditate error. Quod, officiis?</p>
    </div>
</div>  
)
}

export default DescriptionBox